// waring: duplicated source for placeholder, check prime.css
export const placeholder = "placeholder:text-[#80959D]";

export const focusHoverField =
  "focus:outline hover:outline focus-visible:outline-urbe-borderHover focus:outline-urbe-borderHover hover:outline-urbe-borderHover";

export const focusedField = "outline outline-urbe-borderHover";

export const invalidField =
  "border-urbe-errorValidation outline-urbe-errorValidation focus-visible:outline-urbe-errorValidation hover:outline-urbe-errorValidation";
